import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Main from 'components/app/Main';
import PageTwoColumns from 'components/app/PageTwoColumns';
import ErrorMessage from './ErrorMessage';

function ErrorPage({ clearError }) {
  useEffect(() => {
    const unlisten = window.HISTORY.listen(clearError);
    return () => unlisten();
  }, []); // eslint-disable-line

  return (
    <Main>
      <PageTwoColumns>
        <ErrorMessage clearError={clearError} />
      </PageTwoColumns>
    </Main>
  );
}

ErrorPage.propTypes = {
  clearError: PropTypes.func
};

ErrorPage.defaultProps = {
  clearError: PropTypes.func.isRequired
};

export default ErrorPage;
